<!-- Cart Items Section with Enhanced Design -->
<div class="py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
  <div class="container mx-auto">
    <div class="mx-auto">

      <!-- Enhanced Empty Cart State -->
      <div *ngIf="cart.length === 0" class="text-center py-16 sm:py-24">
        <div class="max-w-md mx-auto px-4">
          <div
            class="w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-6 sm:mb-8 shadow-lg">
            <svg class="w-12 h-12 sm:w-16 sm:h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
            </svg>
          </div>
          <h3 class="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">{{ 'Koszyk jest pusty' | translate }}</h3>
          <p class="text-base sm:text-lg text-gray-600 mb-8 sm:mb-12 leading-relaxed">{{ 'Nie dodano jeszcze żadnych\n            produktów. Przejdź do oferty i wybierz potrzebne produkty.' | translate }}</p>
          <a routerLink="/products"
            class="inline-flex items-center justify-center rounded-lg bg-brocom-orange px-8 py-3 font-semibold text-white transition-colors hover:bg-brocom-orange-dark focus:outline-none focus:ring-2 focus:ring-brocom-orange focus:ring-offset-2">
            {{ 'Wróć do oferty' | translate }}
          </a>
        </div>
      </div>

      <!-- Cart Items -->
      <div *ngIf="cart.length > 0">
        <!-- Desktop Cart Layout -->
        <div class="hidden lg:block">
          <!-- Table Header -->
          <div class="bg-white rounded-t-xl shadow-sm border border-gray-200">
            <div class="grid gap-3 p-4 lg:p-6 border-b border-gray-200 bg-gray-50 rounded-t-xl"
              [style.grid-template-columns]="hasDownloads() ? '2.5fr 1.2fr 1.5fr 1.2fr 1fr 1.2fr 0.8fr' : '2.5fr 1.2fr 1.2fr 1fr 1.2fr 0.8fr'">
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide">{{ 'Produkt' | translate }}</div>
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide text-center">{{ 'Ilość' | translate }}
              </div>
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide text-center"
                *ngIf="hasDownloads()">{{ 'Usługi' | translate }}<br>{{ 'dodatkowe' | translate }}</div>
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide text-center">{{ 'Wartość produktów' | translate }}
              </div>
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide text-center">{{ 'VAT' | translate }}</div>
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide text-center">{{ 'Razem brutto' | translate }}
              </div>
              <div class="text-xs lg:text-sm font-semibold text-gray-700 uppercase tracking-wide text-center">{{ 'Akcje' | translate }}
              </div>
            </div>
          </div>

          <!-- Cart Items -->
          <div class="bg-white shadow-sm border-x border-gray-200" *ngFor="let item of cart; let last = last">
            <div class="grid gap-3 p-4 lg:p-6 hover:bg-gray-50 transition-colors items-start"
              [style.grid-template-columns]="hasDownloads() ? '2.5fr 1.2fr 1.5fr 1.2fr 1fr 1.2fr 0.8fr' : '2.5fr 1.2fr 1.2fr 1fr 1.2fr 0.8fr'"
              [class.border-b]="!last" [class.border-gray-200]="!last">
              <!-- Product Info -->
              <div class="flex items-center space-x-2 lg:space-x-4">
                <div class="flex-shrink-0">
                  <a [routerLink]="['/products', item?.product?.id]"
                    [attr.aria-label]="'Zobacz szczegóły produktu ' + (item?.product?.label || '')">
                    <img [src]="item?.product?.documents?.[0]?.url || '/images/placeholder-product.svg'"
                      [alt]="item?.product?.label || 'Zdjęcie produktu'"
                      class="w-20 h-20 lg:w-24 lg:h-24 object-contain rounded-lg border border-gray-200 hover:shadow-lg transition-shadow" />
                  </a>
                </div>
                <div class="flex-1 min-w-0">
                  <h3 class="text-sm lg:text-base font-semibold text-gray-900 mb-1 leading-snug line-clamp-2">
                    <a [routerLink]="['/products', item?.product?.id]"
                      class="hover:text-brocom-orange transition-colors">{{ item?.product?.label }}</a>
                  </h3>
                  <p class="text-xs text-gray-500 mb-2">{{ 'Nr katalogowy:' | translate }} {{ item?.product?.reference || "—" }}</p>
                  <div class="flex flex-wrap gap-x-2 gap-y-1 mb-2">
                    <div *ngFor="let variant of item?.variants | keyvalue" class="flex-shrink-0">
                      <span class="text-xs text-gray-600">
                        {{ getValue(variant.value)?.variant?.label }}:
                        <span class="font-medium text-gray-900">{{ getValue(variant.value)?.value }}</span>
                      </span>
                    </div>
                  </div>

                  <!-- Selected Color -->
                  <div class="mb-2" *ngIf="item?.selectedColor">
                    <span class="text-xs text-gray-600">
                      {{ 'Kolor:' | translate }}
                      <span class="inline-flex items-center gap-1 font-medium text-gray-900">
                        <div class="w-2 h-2 rounded-full border border-gray-300"
                          [style.background-color]="getColorHex(item?.selectedColor?.colorName)"></div>
                        {{ item?.selectedColor?.colorName }}
                      </span>
                    </span>
                  </div>

                  <div class="flex items-center space-x-2">
                    <span class="text-xs text-gray-600">{{ getDeliveryTimeText(item) }}</span>
                  </div>
                </div>
              </div>

              <!-- Quantity Controls -->
              <div class="flex flex-col items-center justify-start pt-2">
                <div class="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                  <button type="button" (click)="decrementQuantity(item)"
                    [disabled]="item?.quantity <= getMinimalQuantity(item)"
                    [attr.aria-label]="'Zmniejsz ilość produktu ' + (item?.product?.label || '')"
                    class="flex items-center justify-center w-10 h-10 text-lg font-medium transition-colors hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed">
                    −
                  </button>
                  <div class="flex items-center justify-center w-12 h-10 text-sm font-medium bg-gray-50">
                    {{ item?.quantity }}
                  </div>
                  <button type="button" (click)="incrementQuantity(item)"
                    [disabled]="!canIncreaseQuantity(item)"
                    [attr.aria-label]="'Zwiększ ilość produktu ' + (item?.product?.label || '')"
                    class="flex items-center justify-center w-10 h-10 text-lg font-medium transition-colors hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed">
                    +
                  </button>
                </div>
                <p *ngIf="!canIncreaseQuantity(item)" class="mt-1 text-xs text-gray-500 text-center">
                  {{ getQuantityLimitMessage(item) }}
                </p>
                <div class="text-xs text-gray-500 mt-1 text-center" *ngIf="getMinimalQuantity(item) > 1">
                  +/- {{ getMinimalQuantity(item) }}
                  {{ item?.product?.unit_sales?.label || item?.product?.unit_product?.label || 'szt.' }}
                </div>
              </div>

              <!-- Downloads Column -->
              <div class="text-center px-2 flex flex-col items-center justify-start pt-2" *ngIf="hasDownloads()">
                <div *ngIf="item?.selectedDownloads && item?.selectedDownloads.length > 0; else noDownloads">
                  <div class="text-xs font-medium text-gray-900 mb-2">
                    {{ 'Wybrane:' | translate }} {{ item?.selectedDownloads.length }}
                  </div>
                  <div class="space-y-1.5">
                    <div *ngFor="let download of item?.selectedDownloads" class="text-xs">
                      <div class="flex items-center justify-center gap-1 mb-0.5">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor" class="w-2.5 h-2.5 text-red-500 flex-shrink-0">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                        </svg>
                        <span class="text-gray-700 truncate max-w-24 text-[10px]" [title]="download.name | translate">{{
                          download.name | translate }}</span>
                      </div>
                      <div class="font-medium text-xs" [class.text-green-600]="parseFloat(download.price || '0') > 0"
                        [class.text-gray-500]="!download.price || parseFloat(download.price || '0') === 0">
                        <span *ngIf="parseFloat(download.price || '0') > 0">{{ parseFloat(download.price || '0') | appendCurrency:shippingCurrency }}</span>
                        <span *ngIf="!download.price || parseFloat(download.price || '0') === 0">{{ 'Bezpłatnie' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noDownloads>
                  <div class="text-xs text-gray-400">
                    {{ 'Brak usług dodatkowych' | translate }}
                  </div>
                </ng-template>
              </div>

              <!-- Quantity Total -->
              <div class="text-center flex flex-col items-center justify-start pt-2">
                <div *ngIf="getItemDiscountPercent(item) > 0; else desktopUndiscountedPrice">
                  <div class="text-xs text-gray-400 line-through mb-1">
                    {{ getOriginalItemTotal(item) | appendCurrency:shippingCurrency }}
                  </div>
                  <div class="text-sm lg:text-base font-bold text-brocom-orange">
                    {{ getDiscountedItemTotal(item) | appendCurrency:shippingCurrency }}
                  </div>
                  <div class="text-xs text-green-600 font-medium">
                    {{ getItemDiscountLabel(item) }}
                  </div>
                </div>
                <ng-template #desktopUndiscountedPrice>
                  <div class="text-sm lg:text-base font-bold text-brocom-orange">
                    {{ getDiscountedItemTotal(item) | appendCurrency:shippingCurrency }}
                  </div>
                  <div class="text-xs text-gray-500 font-medium">
                    {{ 'Wartość produktów' | translate }}
                  </div>
                </ng-template>
              </div>

              <!-- VAT -->
              <div class="text-center flex flex-col items-center justify-start pt-2">
                <div class="text-sm lg:text-base font-bold text-gray-900">
                  {{ getItemVAT(item) | appendCurrency:shippingCurrency }}
                </div>
              </div>

              <!-- Total -->
              <div class="text-center flex flex-col items-center justify-start pt-2">
                <div class="text-sm lg:text-base font-bold text-gray-900">
                  {{ (getItemTotalIncludingVAT(item) + getDownloadsTotal(item)) | appendCurrency:shippingCurrency }}
                </div>
              </div>

              <!-- Delete Action -->
              <div class="hidden sm:flex justify-center items-center justify-start pt-2">
                <button type="button" (click)="removeFromCart(item)"
                  class="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                  [attr.aria-label]="'Usuń ' + (item?.product?.label || 'produkt') + ' z koszyka'">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Bottom Border -->
          <div class="bg-white rounded-b-xl shadow-sm border border-gray-200 border-t-0 h-4"></div>
        </div>

        <!-- Mobile Cart Layout -->
        <div class="lg:hidden">
          <!-- Single Card Container for All Products -->
          <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div *ngFor="let item of cart; let last = last">
              <div class="p-4" [class.border-b]="!last" [class.border-gray-200]="!last">
                <div class="flex items-start gap-3">
                  <a [routerLink]="['/products', item?.product?.id]"
                    [attr.aria-label]="'Pokaż szczegóły produktu ' + (item?.product?.label || 'produkt')">
                    <img [src]="item?.product?.documents?.[0]?.url || '/images/placeholder-product.svg'"
                      [alt]="item?.product?.label || 'Zdjęcie produktu'"
                      class="h-20 w-20 flex-shrink-0 rounded-lg border border-gray-200 object-contain transition-shadow hover:shadow-lg" />
                  </a>
                  <div class="min-w-0 flex-1">
                    <h3 class="mb-1 text-base font-semibold text-gray-900 transition-colors">
                      <a [routerLink]="['/products', item?.product?.id]"
                        class="hover:text-brocom-orange">{{ item?.product?.label }}</a>
                    </h3>
                    <p class="mb-2 text-sm text-gray-500">{{ 'Nr katalogowy:' | translate }} {{ item?.product?.reference || "—" }}</p>

                    <div class="mb-2 flex flex-wrap gap-x-3 gap-y-1">
                      <div *ngFor="let variant of item?.variants | keyvalue" class="flex-shrink-0">
                        <span class="text-sm text-gray-600">
                          {{ getValue(variant.value)?.variant?.label }}:
                          <span class="font-medium">{{ getValue(variant.value)?.value }}</span>
                        </span>
                      </div>
                    </div>

                    <div class="mb-2" *ngIf="item?.selectedColor">
                      <span class="text-sm text-gray-600">
                        {{ 'Kolor:' | translate }}
                        <span class="inline-flex items-center gap-1 font-medium">
                          <span class="h-3 w-3 rounded-full border border-gray-300"
                            [style.background-color]="getColorHex(item?.selectedColor?.colorName)"></span>
                          {{ item?.selectedColor?.colorName }}
                        </span>
                      </span>
                    </div>
                    <p class="text-sm text-gray-600">{{ getDeliveryTimeText(item) }}</p>
                  </div>
                </div>

                <div *ngIf="item?.selectedDownloads?.length" class="mt-4 rounded-lg border border-gray-200 p-3">
                  <p class="mb-2 text-sm font-medium text-gray-700">{{ 'Usługi dodatkowe' | translate }}</p>
                  <div *ngFor="let download of item?.selectedDownloads"
                    class="flex items-center justify-between gap-3 text-sm">
                    <span class="min-w-0 truncate text-gray-600" [title]="download.name | translate">{{ download.name | translate }}</span>
                    <span class="flex-shrink-0 font-medium text-gray-900">
                      <ng-container *ngIf="parseFloat(download.price || '0') > 0">
                        {{ parseFloat(download.price || '0') | appendCurrency:shippingCurrency }}
                      </ng-container>
                      <ng-container *ngIf="parseFloat(download.price || '0') <= 0">{{ 'Bezpłatnie' | translate }}</ng-container>
                    </span>
                  </div>
                </div>

                <div class="mt-4 flex items-center justify-between rounded-lg bg-gray-50 px-3 py-2">
                  <span class="text-sm text-gray-600">{{ 'VAT' | translate }}</span>
                  <span class="font-semibold text-gray-900">
                    {{ getItemVAT(item) | appendCurrency:shippingCurrency }}
                  </span>
                </div>

                <!-- Quantity & Total Section -->
                <div class="p-3 sm:p-4">
                  <div class="flex flex-col space-y-3 sm:space-y-2">
                    <!-- Quantity Controls Row -->
                    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
                      <div class="flex items-center space-x-2 sm:space-x-3">
                        <span class="text-xs sm:text-sm text-gray-600 whitespace-nowrap">{{ 'Ilość:' | translate }}</span>
                        <div class="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                          <button type="button" (click)="decrementQuantity(item)"
                            [disabled]="item?.quantity <= getMinimalQuantity(item)"
                            [attr.aria-label]="'Zmniejsz ilość produktu ' + (item?.product?.label || '')"
                            class="flex items-center justify-center w-8 h-8 text-sm font-medium transition-colors hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed">
                            −
                          </button>
                          <div class="flex items-center justify-center w-10 h-8 text-sm font-medium bg-gray-50">
                            {{ item?.quantity }}
                          </div>
                          <button type="button" (click)="incrementQuantity(item)"
                            [disabled]="!canIncreaseQuantity(item)"
                            [attr.aria-label]="'Zwiększ ilość produktu ' + (item?.product?.label || '')"
                            class="flex items-center justify-center w-8 h-8 text-sm font-medium transition-colors hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed">
                            +
                          </button>
                        </div>
                        <p *ngIf="!canIncreaseQuantity(item)" class="text-xs text-gray-500">
                          {{ getQuantityLimitMessage(item) }}
                        </p>
                      </div>

                      <!-- Quantity Price with proper layout -->
                      <div class="flex items-center justify-between gap-3 p-3 bg-gray-50 rounded-lg">
                        <div class="text-left sm:text-right flex-1">
                          <div *ngIf="getItemDiscountPercent(item) > 0; else mobileUndiscountedPrice">
                            <div class="flex flex-wrap items-center gap-2 text-sm">
                              <span class="text-gray-400 line-through text-xs">
                                {{ getOriginalItemTotal(item) | appendCurrency:shippingCurrency }}
                              </span>
                              <span class="font-semibold text-brocom-orange">
                                {{ getDiscountedItemTotal(item) | appendCurrency:shippingCurrency }}
                              </span>
                              <span class="text-green-600 font-medium text-xs">
                                {{ getItemDiscountLabel(item) }}
                              </span>
                            </div>
                          </div>
                          <ng-template #mobileUndiscountedPrice>
                            <div class="text-sm font-semibold text-brocom-orange">
                              {{ getDiscountedItemTotal(item) | appendCurrency:shippingCurrency }}
                            </div>
                            <div class="text-xs text-gray-400">
                              {{ 'Wartość produktów' | translate }}
                            </div>
                          </ng-template>
                        </div>

                        <!-- Delete Button -->
                        <button type="button" (click)="removeFromCart(item)"
                          class="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors flex-shrink-0"
                          [attr.aria-label]="'Usuń produkt ' + (item?.product?.label || '') + ' z koszyka'"
                          [title]="'Usuń produkt' | translate">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                            </path>
                          </svg>
                        </button>
                      </div>
                    </div>

                    <!-- Increment Info -->
                    <div class="text-xs text-gray-500" *ngIf="getMinimalQuantity(item) > 1">
                      {{ 'Jednorazowo:' | translate }} {{ getMinimalQuantity(item) }} {{ 'szt.' | translate }}
                      {{ item?.product?.unit_sales?.label || item?.product?.unit_product?.label || 'units' }}
                    </div>
                  </div>
                </div>

                <!-- Total -->
                <div
                  class="flex justify-between items-center pb-3 border-b border-gray-200 px-4 py-3 bg-gray-50 rounded-lg">
                  <span class="text-sm text-gray-600">{{ 'Wartość całkowita' | translate }}</span>
                  <div class="text-right">
                    <div class="text-lg font-bold text-gray-900">
                      {{ (getItemTotalIncludingVAT(item) + getDownloadsTotal(item)) | appendCurrency:shippingCurrency }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Voucher Section -->
  <div *ngIf="cart.length > 0" class="py-8 sm:py-10">
    <div class="container mx-auto">
      <div class="grid w-full gap-4 lg:grid-cols-[minmax(0,1fr)_minmax(20rem,1fr)] lg:items-start">
          <div class="rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 shadow-sm">
            <div class="flex items-center space-x-3 mb-4 sm:mb-6">
              <div
                class="w-10 h-10 sm:w-12 sm:h-12 bg-brocom-orange rounded-xl flex items-center justify-center">
                <svg class="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z">
                  </path>
                </svg>
              </div>
              <div>
                <h3 class="text-lg sm:text-xl font-bold text-gray-900">{{ 'Masz kod rabatowy?' | translate }}</h3>
                <p class="text-xs sm:text-sm text-orange-600 font-medium">{{ 'Obniż wartość zamówienia' | translate }}</p>
              </div>
            </div>

            <!-- Applied Voucher Display -->
            <div *ngIf="appliedVoucher" class="bg-green-50 rounded-lg p-4 mb-4 border border-green-200">
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-3">
                  <div class="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                    <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <div>
                    <div class="text-sm font-semibold text-green-800">
                      {{ 'Zastosowano kod rabatowy:' | translate }} {{ appliedVoucher.code }}
                    </div>
                    <div class="text-xs text-green-600">
                      {{ getVoucherDisplayText() }} - {{ appliedVoucher.description || 'Rabat został naliczony' }}
                    </div>
                  </div>
                </div>
                <button type="button" (click)="removeVoucher()"
                  class="text-orange-500 hover:text-orange-700 p-1"
                  [attr.aria-label]="'Usuń kod rabatowy' | translate">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Voucher Input Form -->
            <div *ngIf="!appliedVoucher">
              <p class="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                {{ 'Wpisz poniżej kod rabatowy, aby obniżyć wartość zamówienia.' | translate }}
              </p>

              <!-- Error Message -->
              <div *ngIf="voucherError" role="alert" class="bg-red-50 rounded-lg p-3 mb-4 border border-red-200">
                <div class="flex items-center space-x-2">
                  <svg class="w-4 h-4 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <span class="text-sm text-red-700">{{ voucherError }}</span>
                </div>
              </div>

              <!-- Input and Button -->
              <div class="flex flex-col space-y-3 sm:flex-row sm:items-end sm:space-y-0 sm:space-x-3">
                <div class="flex-1">
                  <label for="checkout-voucher-code" class="mb-1.5 block text-sm font-medium text-gray-700">
                    {{ 'Kod rabatowy' | translate }}
                  </label>
                  <input id="checkout-voucher-code" name="voucherCode" type="text" [(ngModel)]="voucherCode"
                    (input)="onVoucherCodeChange()" (keyup.enter)="applyVoucher()"
                    [placeholder]="'Wpisz kod rabatowy' | translate"
                    class="w-full px-4 py-3 sm:px-5 sm:py-4 text-sm border-2 border-orange-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all bg-white shadow-sm uppercase"
                    [disabled]="applyingVoucher" />
                </div>
                <button type="button" (click)="applyVoucher()"
                  [disabled]="applyingVoucher || !voucherCode.trim()"
                  class="px-6 py-3 sm:px-8 sm:py-4 text-sm rounded-xl font-semibold transition-all whitespace-nowrap shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  [class.bg-gradient-to-r]="!applyingVoucher && voucherCode.trim()"
                  [class.from-orange-500]="!applyingVoucher && voucherCode.trim()"
                  [class.to-orange-600]="!applyingVoucher && voucherCode.trim()"
                  [class.text-white]="!applyingVoucher && voucherCode.trim()"
                  [class.hover:from-orange-600]="!applyingVoucher && voucherCode.trim()"
                  [class.hover:to-orange-700]="!applyingVoucher && voucherCode.trim()"
                  [class.bg-gray-100]="applyingVoucher || !voucherCode.trim()"
                  [class.text-gray-500]="applyingVoucher || !voucherCode.trim()">
                  <span *ngIf="!applyingVoucher">{{ 'Zastosuj kod' | translate }}</span>
                  <span *ngIf="applyingVoucher" class="flex items-center space-x-2" role="status" aria-live="polite">
                    <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                      </path>
                    </svg>
                    <span>{{ 'Stosowanie kodu…' | translate }}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <section aria-labelledby="basket-estimate-title"
            class="rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 shadow-sm">
            <h3 id="basket-estimate-title" class="text-lg font-semibold text-gray-900">{{ 'Podsumowanie koszyka' | translate }}</h3>
            <div class="mt-4 flex items-center justify-between gap-4 text-sm text-gray-600">
              <span>{{ 'Produkty (brutto)' | translate }}</span>
              <span class="font-medium text-gray-900">
                {{ getCartTotalMatchingRows() | appendCurrency:shippingCurrency }}
              </span>
            </div>
            <div *ngIf="appliedVoucher" class="mt-3 flex items-center justify-between gap-4 text-sm text-green-700">
              <span>{{ 'Rabat z kodu' | translate }}</span>
              <span class="font-medium">-{{ voucherDiscountAmount | appendCurrency:shippingCurrency }}</span>
            </div>
            <div class="mt-4 flex items-center justify-between gap-4 border-t border-gray-200 pt-4">
              <div>
                <p class="font-semibold text-gray-900">{{ 'Szacowana kwota przed doliczeniem dostawy' | translate }}</p>
                <p class="mt-1 text-xs text-gray-500">{{ 'Zawiera VAT i wybrane usługi dodatkowe' | translate }}</p>
              </div>
              <span class="text-lg font-bold text-gray-900">
                {{ getCartTotalWithVoucher() | appendCurrency:shippingCurrency }}
              </span>
            </div>
            <p class="mt-3 text-xs leading-relaxed text-gray-500">
              {{ 'Koszt dostawy zostanie obliczony po podaniu adresu. Ostateczna kwota będzie widoczna przed płatnością.' | translate }}
            </p>
          </section>
      </div>
    </div>
  </div>